import { render, staticRenderFns } from "./RightsTable.vue?vue&type=template&id=3ee5eeca&scoped=true"
import script from "./RightsTable.vue?vue&type=script&lang=js"
export * from "./RightsTable.vue?vue&type=script&lang=js"
import style0 from "./RightsTable.vue?vue&type=style&index=0&id=3ee5eeca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee5eeca",
  null
  
)

export default component.exports